import React from "react";
import { faAdjust as lightAdjust, faSun as lightSun } from "@fortawesome/pro-light-svg-icons";
import { faSun as solidSun } from "@fortawesome/free-solid-svg-icons";
import { faUndo, faAdjust as solidAdjust } from "@fortawesome/pro-regular-svg-icons";
import { resetStillImageAdjustments, setStillImageAdjustments } from "redux/actions";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Slider, Tooltip } from "antd";

const sourceIndexSelector = (state) => state.playlist.position.sourceIndex;
const currentStillImageAdjustmentsSelector = (state) => state.playlist.stillImageAdjustments;

const ImageAdjustmentsComponent = (props) => {
    const dispatch = useDispatch();
    const sourceIndex = useSelector(sourceIndexSelector);
    const currentStillImageAdjustments = useSelector(currentStillImageAdjustmentsSelector);

    const handleReset = () => {
        dispatch(resetStillImageAdjustments());
    };

    const handleChange = (val, adjustmentType) => {
        dispatch(setStillImageAdjustments(val, adjustmentType, sourceIndex));
    };

    return (
        <div className={`${props.className} inspectRail__Adjustments__Item-Container`}>
            <div className="titleContainer">
                <p>Image Adjustments</p>
                <FontAwesomeIcon
                    icon={faUndo}
                    onClick={handleReset}
                />
            </div>

            <div className="inspectRail__Adjustments__Item">
                <Tooltip
                    title="Brightness"
                    placement="top">
                    <FontAwesomeIcon icon={lightSun} />
                </Tooltip>
                <Slider
                    step={0.1}
                    min={-1}
                    max={1}
                    onChange={(e) => handleChange(e, "brightness")}
                    value={_.get(currentStillImageAdjustments, [sourceIndex, "brightness"], 0)}
                />
                <FontAwesomeIcon icon={solidSun} />
            </div>
            <div className="inspectRail__Adjustments__Item">
                <Tooltip
                    title="Contrast"
                    placement="top">
                    <FontAwesomeIcon icon={lightAdjust} />
                </Tooltip>
                <Slider
                    step={0.1}
                    min={-1}
                    max={1}
                    onChange={(e) => handleChange(e, "contrast")}
                    value={_.get(currentStillImageAdjustments, [sourceIndex, "contrast"], 0)}
                />
                <FontAwesomeIcon icon={solidAdjust} />
            </div>
        </div>
    );
};

export default ImageAdjustmentsComponent;
